/* Direct Shopify checkout for product and homepage purchase actions. */
(() => {
  const getForm = (button) => button.closest('form');
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-y-direct-checkout]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const form = getForm(button);
    const variant = form?.querySelector('input[name="id"]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const id = Number(variant?.value || 0);
    const quantity = Number(quantityInput?.value || 1);
    if (!id || !Number.isInteger(quantity) || quantity < 1 || (quantityInput && quantityInput.max && quantity > Number(quantityInput.max))) {
      window.alert('Select an available option and a valid quantity.');
      return;
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-checkout-loading');
    // Allow the browser to render the spinner before starting the network request.
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        credentials: 'same-origin',
        body: JSON.stringify({items:[{id,quantity}]})
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to add this item.');
      }
      window.location.assign(root + 'checkout');
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-checkout-loading');
      window.alert(error.message || 'Unable to continue to checkout. Please try again.');
    }
  });
})();
